import { defineMessages, FormattedMessage } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import Typography from '@alltrails/core/components/Typography';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import leftImg from '../../assets/images/stats/stats-left.avif';
import middleImg from '../../assets/images/stats/stats-middle.avif';
import rightImg from '../../assets/images/stats/stats-right.avif';
import leftImgMobile from '../../assets/images/stats/stats-left-mobile.avif';
import middleImgMobile from '../../assets/images/stats/stats-middle-mobile.avif';
import rightImgMobile from '../../assets/images/stats/stats-right-mobile.avif';
import CommunityStats from '../CommunityStats';
import { PressNavId } from '../../utils/press.strings';
import styles from './styles/styles.module.scss';

/* Figma design: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Rebrand%E2%80%93Press%2FAbout%2F404?node-id=1701%3A10751&t=Ehj2ZVmrAOWAcLYQ-1 */

const AboutSection = () => {
  const IMAGE_ALTS = defineMessages({
    LEFT_IMAGE_ALT: {
      defaultMessage: 'A person sitting on a rock and looking at a waterfall'
    },
    MIDDLE_IMAGE_ALT: {
      defaultMessage: 'A person on a hiking trail with a mountain in the background'
    },
    RIGHT_IMAGE_ALT: {
      defaultMessage: 'A person sitting on a boulder and smiling'
    }
  });

  const {
    formattedDefaultMessages: { LEFT_IMAGE_ALT, MIDDLE_IMAGE_ALT, RIGHT_IMAGE_ALT }
  } = useFormatMessage(IMAGE_ALTS);

  const isMobile = useIsMobileSizedScreen();

  return (
    <div id={PressNavId.About} className={styles.container}>
      <div className={styles.textContainer}>
        <Typography component="h2" variant="heading500" className={styles.header}>
          <FormattedMessage defaultMessage="Helping people across the globe get outside" />
        </Typography>
        <p className={styles.description}>
          <FormattedMessage defaultMessage="AllTrails believes that the outside isn't a place to seek, but rather a part of each and every one of us. We help people worldwide plan, live, and share their adventures, from mountain treks to strolls in the park." />
        </p>
      </div>
      <div className={styles.imgContainer}>
        <Image src={isMobile ? leftImgMobile : leftImg} alt={LEFT_IMAGE_ALT} className={styles.leftImg} loading="lazy" />
        <Image src={isMobile ? middleImgMobile : middleImg} alt={MIDDLE_IMAGE_ALT} className={styles.middleImg} loading="lazy" />
        <Image src={isMobile ? rightImgMobile : rightImg} alt={RIGHT_IMAGE_ALT} className={styles.rightImg} loading="lazy" />
      </div>
      <CommunityStats />
    </div>
  );
};

export default AboutSection;
